export default __webpack_public_path__ + "static/media/moc.1d8ca05d.png";